import React from "react";
import AppRouter from "./routes";
import { ReactNotifications } from 'react-notifications-component'
// import '@fontsource/roboto/300.css';
// import '@fontsource/roboto/400.css';
// import '@fontsource/roboto/500.css';
// import '@fontsource/roboto/700.css';


// import 'bootstrap/dist/css/bootstrap.min.css';

// import styles
import './App.scss';
import './assets/scss/style.scss';
import { AuthProvider } from "./context";

function App() {
  return (
    <AuthProvider>
       <ReactNotifications />
      <AppRouter />
    </AuthProvider>
  );
}

export default App;
